import { createPartnerBasicInfo } from 'legacy/lut/services/partner360/basicInfo/createPartnerBasicInfo'
import { mapFormBasicInfoTo1091 } from 'legacy/lut/services/partner360/basicInfo/mappings/mapFormBasicInfoTo1091'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { selectFinancialYear, selectPartnerId } from '../../configuration'
import { CREATE_DEFAULT_BASIC_INFO_DATA } from '../constants'
import { isBasicInfoDefault } from '../helpers/typeGuards'
import { IFormBasicInfo } from '../models/formBasicInfo'
import { TBasicInfoDefault } from '../models/partnerBasicInfo'

export const createDefaultBasicInfo = createAsyncThunk<
  TBasicInfoDefault | undefined,
  IFormBasicInfo
>(CREATE_DEFAULT_BASIC_INFO_DATA, async (formData, { getState }) => {
  const state = getState()

  const partnerId = selectPartnerId(state)
  const fYear = selectFinancialYear(state)

  const mappedData = mapFormBasicInfoTo1091(formData)
  const defaultData = await createPartnerBasicInfo({
    ...mappedData,
    PartnerId: partnerId,
    FYear: fYear,
    ProgramType: null,
  })

  return isBasicInfoDefault(defaultData) ? defaultData : undefined
})
